/*
 *
 * NewTreatmentTreatmentStep constants
 *
 */

export const DEFAULT_ACTION = "app/NewTreatmentTreatmentStep/DEFAULT_ACTION";

/**
 * Get treatment plan
 */
export const GET_TREATMENT_PLAN =
  "app/NewTreatmentTreatmentStep/GET_TREATMENT_PLAN";
export const GET_TREATMENT_PLAN_SUCCES =
  "app/NewTreatmentTreatmentStep/GET_TREATMENT_PLAN_SUCCES";
export const GET_TREATMENT_PLAN_FAILED =
  "app/NewTreatmentTreatmentStep/GET_TREATMENT_PLAN_FAILED";

/**
 * Other
 */
export const POP_UP_TREATMENT_PLANS = [12];

/**
 * Urls
 */
export const TREATMENT_PLAN_URL = "/treatmentPlans";
